module.exports = __webpack_public_path__ + "img/search1.2037364a.png";